export const GET_TYPE_INVENTORY_INCIDENT = 'GET_TYPE_INVENTORY_INCIDENT'
export const GET_TYPE_INVENTORY_INCIDENT_EXITO =
  'GET_TYPE_INVENTORY_INCIDENT_EXITO'
export const GET_TYPE_INVENTORY_INCIDENT_ERRROR =
  'GET_TYPE_INVENTORY_INCIDENT_ERROR'
